import { useEffect, useState } from "preact/hooks";
import { api, type OutOfOffice as Settings } from "../api";

// <input type="datetime-local"> travaille en heure locale, sans fuseau.
const toLocal = (ms: number | null) => {
  if (ms === null) return "";
  const d = new Date(ms);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
};
const fromLocal = (v: string) => (v ? new Date(v).getTime() : null);

// Réponse automatique d'absence (exigence C4).
export function OutOfOffice({ notify }: { notify: (text: string) => void }) {
  const [ooo, setOoo] = useState<Settings | null>(null);
  const [addresses, setAddresses] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Promise.all([api.outOfOffice(), api.folders()]).then(([o, f]) => {
      setOoo(o);
      setAddresses([...new Set([...f.addresses.map((a) => a.address), ...o.addresses])].sort());
    }).catch(() => {});
  }, []);
  if (!ooo) return null;

  const save = async (next: Settings) => {
    setError(null);
    try {
      setOoo(await api.setOutOfOffice(next));
      notify(next.enabled ? "Réponse d'absence activée" : "Réponse d'absence enregistrée");
    } catch (e) {
      setError((e as Error).message);
    }
  };
  const toggle = (address: string, on: boolean) =>
    setOoo({ ...ooo, addresses: on ? [...ooo.addresses, address] : ooo.addresses.filter((a) => a !== address) });

  return (
    <>
      <h2>Absence</h2>
      <p class="sub">
        Répond une fois par semaine au plus à chaque personne qui écrit à une adresse cochée, jamais aux
        envois automatiques, aux listes de diffusion ni au spam. Nécessite l'envoi par Resend. Un e-mail
        écrit à une adresse d'un autre domaine (Expédition, ci-dessus) reçoit la réponse depuis celle-ci.
      </p>
      <label class="setting">
        <span>Message</span>
        <textarea rows={4} value={ooo.text} placeholder="Je suis absent jusqu'au… Pour une urgence, écrivez à…"
          onInput={(e) => setOoo({ ...ooo, text: (e.target as HTMLTextAreaElement).value })} />
      </label>
      <label class="setting">
        <span>Objet (facultatif, sinon « Réponse automatique : » suivi de l'objet reçu)</span>
        <input value={ooo.subject} onInput={(e) => setOoo({ ...ooo, subject: (e.target as HTMLInputElement).value })} />
      </label>
      <div class="rule-row">
        <label class="setting">
          <span>Du (facultatif)</span>
          <input type="datetime-local" value={toLocal(ooo.from)} onInput={(e) => setOoo({ ...ooo, from: fromLocal((e.target as HTMLInputElement).value) })} />
        </label>
        <label class="setting">
          <span>Au (facultatif)</span>
          <input type="datetime-local" value={toLocal(ooo.until)} onInput={(e) => setOoo({ ...ooo, until: fromLocal((e.target as HTMLInputElement).value) })} />
        </label>
      </div>
      <p class="sub">Adresses concernées :</p>
      {addresses.map((a) => (
        <label class="check">
          <input type="checkbox" checked={ooo.addresses.includes(a)} onChange={(e) => toggle(a, (e.target as HTMLInputElement).checked)} />
          {a}
        </label>
      ))}
      {error && <p class="error" role="alert">{error}</p>}
      <p class="rule-buttons">
        {ooo.enabled ? (
          <>
            <button class="btn primary" onClick={() => save(ooo)}>Enregistrer</button>
            <button class="btn danger" onClick={() => save({ ...ooo, enabled: false })}>Désactiver</button>
          </>
        ) : (
          <button class="btn primary" onClick={() => save({ ...ooo, enabled: true })}>Activer la réponse d'absence</button>
        )}
      </p>
      {ooo.enabled && <p class="sub">Active{ooo.until ? ` jusqu'au ${new Date(ooo.until).toLocaleString("fr-FR", { dateStyle: "long", timeStyle: "short" })}` : ""}.</p>}
    </>
  );
}
